<template>
  <div>
    <alert-message :message="message"></alert-message>
    <alert-error :errors="errors"></alert-error>
  </div>
</template>
<script>
  export default {
    props: ['errors', 'message']
  }
</script>



// WEBPACK FOOTER //
// Compact.vue?1d0da091